import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  MenuItem,
  Grid,
} from "@material-ui/core";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { validationFromSchema } from "../util";
import { $Service, Service } from "../_generated";

export default function ServiceEditDialog(props: {
  open: boolean;
  service?: Service;
  onCancel: () => any;
  onSubmit: (data: Service) => any;
}) {
  const { register, handleSubmit, errors, control } = useForm();
  return (
    <Dialog open={props.open}>
      <form
        onSubmit={handleSubmit((data: any) =>
          props.onSubmit({ ...props.service, ...data })
        )}
      >
        <DialogTitle>{props.service ? "Edit" : "Create"} Service</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                inputRef={register(
                  validationFromSchema($Service.properties.name)
                )}
                label="Name"
                name="name"
                defaultValue={props.service?.name ?? ""}
                error={errors.name !== undefined}
                helperText={errors.name?.message}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="service_type"
                defaultValue={props.service?.service_type ?? serviceTypes[0]}
                render={({ onChange, value, ref }) => (
                  <TextField
                    select
                    label="Service type"
                    value={value}
                    onChange={onChange}
                    inputRef={ref}
                    fullWidth
                  >
                    {serviceTypes.map((serviceType) => (
                      <MenuItem value={serviceType} key={serviceType}>
                        {serviceType}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                inputRef={register(
                  validationFromSchema($Service.properties.repository)
                )}
                label="Repository"
                name="repository"
                defaultValue={props.service?.repository}
                error={errors.repository !== undefined}
                helperText={errors.repository?.message}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                inputRef={register(
                  validationFromSchema($Service.properties.dockerfile)
                )}
                label="Dockerfile"
                name="dockerfile"
                defaultValue={props.service?.dockerfile}
                error={errors.dockerfile !== undefined}
                helperText={errors.dockerfile?.message}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                inputRef={register(
                  validationFromSchema($Service.properties.health_check)
                )}
                label="Health check"
                name="health_check"
                defaultValue={props.service?.health_check}
                error={errors.health_check !== undefined}
                helperText={errors.health_check?.message}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                inputRef={register(
                  validationFromSchema($Service.properties.container_port)
                )}
                label="Container port"
                name="container_port"
                defaultValue={props.service?.container_port}
                error={errors.container_port !== undefined}
                helperText={errors.container_port?.message}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="submit">{props.service ? "Save" : "Create"}</Button>
          <Button onClick={props.onCancel}>Cancel</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

const serviceTypes = ["container", "serverless"];
